export const FeedbackMaxCharsAllowed: number = 4000;
